<template>
  <div class="nr_container_content business_page_tabs">
    <v-card>
      <v-tabs

          v-model="tab"
          background-color="white"
          white
      >
        <v-tab v-for="item in items" :key="item.tab">
          {{ item.tab }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="mt-60">
        <v-tab-item v-for="item in items" :key="item.tab">
          <v-card flat>
            <v-card-text class="my-0 my-sm-5" v-for="el in item.content">
              <div class="row">
                <div class="col-12 col-md-4">
                  <div v-if="!el.download"
                       class="business_page_tabs__img d-flex align-items-center justify-content-center">
                    <img :src="el.img">
                  </div>
                  <div v-else-if="el.download"
                       class="business_page_tabs__img d-flex align-items-center justify-content-center">
                    <div
                        class="business_page_tabs__file position-relative h-100 d-flex flex-column  justify-content-between">
                      <div class="type_file">PDF</div>
                      <div class="download_file w-100 d-flex align-items-center justify-content-between">
                        <span>Скачать</span>
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M26.25 18.75V23.75C26.25 24.413 25.9866 25.0489 25.5178 25.5178C25.0489 25.9866 24.413 26.25 23.75 26.25H6.25C5.58696 26.25 4.95107 25.9866 4.48223 25.5178C4.01339 25.0489 3.75 24.413 3.75 23.75V18.75"
                              stroke="white" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"/>
                          <path d="M8.75 12.5L15 18.75L21.25 12.5" stroke="white"
                                stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"/>
                          <path d="M15 18V1" stroke="white" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>

                      </div>
                      <a :href="el.download" class="position-absolute t-0 l-0 w-100 h-100 zi-1"></a>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-8">
                  <div class="business_page_tabs__title">{{ el.title }}</div>
                  <div class="business_page_tabs__descr" v-html="el.descr">

                    {{ el.descr }}

                    <!--оригинал передаваемого шаблона -->
                    <!--<p><strong>Область применения:</strong> Предназначены для защиты поверхности от-->
                    <!--попадания краски при проведении окрасочных работ, склеивания и фиксации-->
                    <!--поверхностей. Не оставляют следов клея и не нарушают целостность поверхности-->
                    <!--при снятии в течение 24 часов после наклеивания. </p>-->
                    <!--<p> Имеют высокие потребительские характеристики, экономичные намотки и идеально-->
                    <!--подходят для бытового применения. Декларируемые параметры всегда-->
                    <!--соответствуют реальным значениям. </p>-->
                    <!--<p><strong>Состав:</strong> BOPP пленка, акриловый клей. </p>-->
                    <!--<div class="row">-->
                    <!--<div class="col-12 col-sm-6">-->
                    <!--<div><strong>Ширина:</strong> 48 мм</div>-->
                    <!--<div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="col-12 col-sm-6">-->
                    <!--<div><strong>Толщина:</strong> 38 мкм</div>-->
                    <!--<div><strong>Цвет:</strong> прозрачный</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--оригинал передаваемого шаблона -->
                  </div>

                  <div class="business_page_tabs__buy ">
                    <button class="btn_red" @click="btn_buy(el)">Купить</button>
                  </div>
                </div>
              </div>

            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>

</template>

<script>

export default {
  props: {
    items: Array | String | Number | Boolean | Object,
  },
  name: "BusinessTabs",
  data() {
    return {
      tab: null,
      // items: [
      //   {
      //     tab: 'Стретч-плёнки',
      //     content: {
      //       0: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: false,
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //       1: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: "url",
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //
      //     },
      //   },
      //   {
      //     tab: 'Клейкие ленты',
      //     content: {
      //       0: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: "url",
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //       1: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: "url",
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //
      //     },
      //   },
      //   {
      //     tab: 'Специальные ленты',
      //     content: {
      //       0: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: "url",
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //       1: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: "url",
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //
      //     },
      //   },
      //   {
      //     tab: 'Стреппинг ленты',
      //     content: {
      //       0: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: "url",
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //       1: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: "url",
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //
      //     },
      //   },
      //   {
      //     tab: 'Клейкие ленты с печатью',
      //     content: {
      //       0: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: "url",
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //       1: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: "url",
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //
      //     },
      //   },
      //   {
      //     tab: 'Воздушно-пузырьковая пленка',
      //     content: {
      //       0: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: false,
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //       1: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: "url",
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //
      //     },
      //   },
      //   {
      //     tab: 'Инструменты и расходники',
      //     content: {
      //       0: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: false,
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //       1: {
      //         img: "/local/templates/international/img/25-03-2022 141516 1.jpg",
      //         download: "url",
      //         title: "NOVAROLL",
      //         descr: '<p><strong>Область применения:</strong> Предназначены для защиты поверхности от попадания краски при проведении окрасочных работ, склеивания и фиксации поверхностей. Не оставляют следов клея и не нарушают целостность поверхности при снятии в течение 24 часов после наклеивания. </p> <p> Имеют высокие потребительские характеристики, экономичные намотки и идеально подходят для бытового применения. Декларируемые параметры всегда соответствуют реальным значениям. </p> <p> <strong>Состав:</strong> BOPP пленка, акриловый клей. </p> <div class="row"> <div class="col-12 col-sm-6"> <div><strong>Ширина:</strong> 48 мм</div> <div><strong>Длина:</strong> 40 м, 50 м, 57 м, 66 м, 100 м, 120 м, 150 м </div> </div> <div class="col-12 col-sm-6"> <div><strong>Толщина:</strong> 38 мкм</div> <div><strong>Цвет:</strong> прозрачный</div> </div> </div>',
      //       },
      //
      //     },
      //   },
      // ],
    };
  },
  methods: {
    // ...mapActions({
    //   addId: 'addId' // map `this.add()` to `this.$store.dispatch('increment')`
    // }),
    btn_buy(el) {
        ym(88483883, 'reachGoal', 'clickBuyButton');
      document.querySelector('.contact_btn a').dispatchEvent(new MouseEvent('click'));

      // el.id - какой-нибудь передай пропс для item и засандаль вместо 12345
     // запись в глобальное хранилище через мутацию в опцию idMaterial /int_site/src/store/index.js
      this.$store.commit('addId', el.id); // вызов мутации для записи значения - по сути простая функция в mutations
    },

  },

};
</script>

<style lang="scss">
@import "../../theme/_variable.scss";

.business_page__img img {
  width: 100%;
  max-width: 757px;
}
body .business_page_tabs {
  margin-top: 80px;
  & .business_page_tabs__descr {
    font-family: $font-Museo500;
    font-style: normal;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: -0.01em;
    color: #202020;
  }
  & .business_page_tabs__file {
    min-height: 200px;
    //background: #AF5D5E;
    background: url("/local/templates/international/img/bg1.jpg");
    width: 100%;
    padding: 16px 20px;
    border-radius: 12px;
    background-repeat: no-repeat;

    & * {
      font-family: $font-Museo500;
      font-style: normal;
      font-size: 18px;
      line-height: 100%;
      color: #FFFFFF;
    }
  }

  .business_page_tabs__buy {
    margin-top: 30px;
    margin-bottom: 15px;

    & a,
    & button {
      background: #FA5A50;
      border-radius: 12px;
      padding: 10px 51px;
    }
  }

  .business_page_tabs__descr *,
  .business_page_tabs__descr p {
    font-family: $font-Museo500;
    font-style: normal;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: -0.01em;
    color: #202020;
  }

  .my-5 {
    margin-top: 30px !important;
    margin-bottom: 30px !important;
  }

  & .v-tabs-bar {
    order-radius: 12px;
    background-color: #FAFAFA !important;
    box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.06);
  }

  & .v-card__text {
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 2px rgb(0 0 0 / 6%);
    border-radius: 20px;
  }

  & .business_page_tabs__img {
    & img {
      width: 310px;
    }
  }

  & .business_page_tabs__title {
    font-family: $font-Museo700;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 100%;
    text-transform: uppercase;
    color: #FF4237;
    margin-bottom: 32px;
  }

  & .v-slide-group__next,
  & .v-slide-group__prev {
    position: absolute;
    display: flex;
    -webkit-align-items: center;
    align-items: center;
    height: 100%;
    min-width: 0;
    z-index: 2;

    & i {
      background: #F35E55;
      border: 1px solid #F35E55;
      box-sizing: border-box;
      border-radius: 50%;
      color: #fff;
    }
  }

  & .v-slide-group__next {
    right: -3px;
  }

  & .v-slide-group__prev {
    left: -3px;
  }

  & .v-tabs-slider {
    display: none;
  }

  & .v-tab {
    font-family: $font-Museo700;
    font-style: normal;
    font-size: 16px;
    line-height: 100%;
    color: #282828;
    text-transform: none;
    letter-spacing: inherit;

    &.v-tab--active {
      color: #FFFFFF;
      caret-color: #FFFFFF !important;
      background: #FA5A50;
      border-radius: 12px;
    }
  }

  & .v-sheet.v-card {
    padding: 5px;

  }

  .v-card__text.my-5 {
    display: inline-block;
  }

  & .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
  }

  .theme--light.v-tabs .v-tab:hover::before {
    caret-color: #FFFFFF !important;
    background: #FA5A50;
    border-radius: 12px;
  }

  .v-tab:focus:before,
  .v-tab:active:before,
  .v-tab:hover:before,
  .v-tab:before {
    background: #FA5A50;
    border-radius: 12px;
  }
}


</style>
